import React, { useState, useEffect } from "react";
import "./vortex-download.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

import StatusCard from "../addonstatus/StatusCard";
import useStatus from "../addonstatus/useStatus";

const defaultAddons = [
  {
    name: "Prison Addons",
    version: "Loading...",
    mcVersion: "Loading...",
    releaseDate: "Loading...",
    lastUpdate: "Loading...",
    downloads: "Loading...",
    changelog: [
      "📜 **Prison Addon v1.7**",

      "",

      "🔄 UPDATE OVERVIEW",
      "This major update introduces a complete custom crate system, new selling features, player payments, improved economy handling, and major backend improvements for a better prison experience.",

      "",

      "✨ ADDED",
      "• Added a complete customizable crate system",
      "• Added unlimited custom crates",
      "• Added custom crate reward creation",
      "• Added crate reward editing and deletion",
      "• Added custom reward chances",
      "• Added reward command support",
      "• Added physical crate keys",
      "• Added scoreboard crate key support",
      "• Added automatic crate key overflow",
      "• Added crate preview menu",
      "• Added crate opening animations",
      "• Added crate opening sounds",
      "• Added global crate win announcements",

      "",

      "🎁 CRATE SYSTEM UPDATE",
      "• Added unlimited custom crates",
      "• Added customizable crate rewards",
      "• Added reward editing and deletion",
      "• Added configurable reward chances",
      "• Added command-based rewards",
      "• Added physical crate keys",
      "• Added scoreboard key storage",
      "• Added automatic key overflow",
      "• Improved reward saving and loading",
      "• Improved crate management",
      "• Improved crate UI",

      "",

      "🔑 KEY STORAGE",
      "• Players can hold up to 64 physical crate keys in their inventory",
      "• Additional keys are automatically stored using the scoreboard system",
      "• Improved key handling for large quantities",
      "• Improved physical key consumption",
      "• Improved scoreboard key consumption",

      "",

      "🛒 SELL SHOP",
      "• Added /sell",
      "• Added /sell all",
      "• Added /sell hand",
      "• Added Sell Booster support",
      "• Added raw ore support",
      "• Added smelted ingot support",
      "• Added automatic money formatting",
      "• Added support for large economy values",

      "",

      "💰 ECONOMY UPDATE",
      "• Added /pay command",
      "• Players can now send money to other players",
      "• Added support for 1K, 10K, 100K, 1M, 10M and 1B formats",
      "• Added automatic large-number formatting",
      "• Improved economy handling",

      "",

      "⛏️ MINE & GAMEPLAY",
      "• Improved overall prison gameplay systems",
      "• Improved mine and progression compatibility",
      "• Improved inventory handling",
      "• Improved backend systems",
      "• Improved support for larger prison systems",

      "",

      "🛠️ FIXES",
      "• Fixed crate not found errors",
      "• Fixed rewards not displaying correctly",
      "• Fixed rewards not giving items correctly",
      "• Fixed reward deletion issues",
      "• Fixed reward chance issues",
      "• Fixed crate preview issues",
      "• Fixed crate opening issues",
      "• Fixed physical crate keys not being consumed correctly",
      "• Fixed scoreboard crate keys being consumed incorrectly",
      "• Fixed key overflow issues",
      "• Fixed custom reward command issues",
      "• Fixed reward saving and loading issues",
      "• Various bug and stability fixes",

      "",

      "⚙️ IMPROVEMENTS",
      "• Faster crate loading",
      "• Improved reward saving",
      "• Improved reward editing",
      "• Improved crate management",
      "• Cleaner crate UI",
      "• Improved inventory handling",
      "• Improved scoreboard handling",
      "• Improved command support",
      "• Improved overall addon stability",
      "• Backend performance optimizations",

      "",

      "⚠️ NOTES",
      "• Replace all old addon files before updating",
      "• Restart your world/server after updating",
      "• Make sure you are running Minecraft Bedrock v1.26.20 or newer",
      "• This addon is still in Alpha and features may change",

      "",

      "🚀 COMING SOON",
      "• 📜 Daily & Weekly Quests",
      "• 🎁 Daily Rewards",
      "• 💼 Black Market",
      "• 🏦 Player Vaults",
      "• 📊 Leaderboards",
      "• 🎣 Fishing System",
      "• ⚒️ Custom Enchantments Expansion",
      "• More prison progression systems",
      "• More customization options",
      "• More GUI improvements",
      "• Additional performance optimizations 👀"

    ],

    versionUrl:
      "https://raw.githubusercontent.com/RealModking/Vortex-Prison-addon/main/version.json",
    icon: "fa-gavel",
    description:
      "Advanced Minecraft Bedrock prison addons with mines, backpacks, auto sell, ranks, enchants, prestiges, crates, and more.",
    features: ["Auto sell", "Backpacks", "Enchants", "Ranks"],
    ptext: "",
    curseforge:
      "https://www.curseforge.com/minecraft-bedrock/scripts/prison-addon/download/8260017",
    mcpedl: "https://mcpedl.com/prison-addon",
    newdownloadlink: "https://vortexnetowrknew.co.uk/download/VNPrisonBP.zip",
    withoutdy: null
  },
  {
    name: "SkyBlock Addon",
    version: "Loading...",
    mcVersion: "Loading...",
    releaseDate: "Loading...",
    lastUpdate: "Loading...",
    changelog: [
      "📜 SkyBlock Addon v1.0.0 (Beta)",
      "",
      "🆕 Initial Beta Release",
      "",
      "🏝️ Island System",
      "• Create and manage your own SkyBlock island",
      "• Invite friends to join your island",
      "• Island member management",
      "",
      "💰 Economy",
      "• Player balance system",
      "• Bank accounts",
      "• Player payments",
      "• Buy & sell shops",
      "",
      "⚙️ Progression",
      "• Island upgrades",
      "• Island leveling",
      "• Island value tracking",
      "• Custom generators",
      "",
      "🌾 Gameplay",
      "• Farming support",
      "• Mining progression",
      "• Mob farming support",
      "",
      "🏪 Features",
      "• Player Shops",
      "• Auction House",
      "• Shared Island Bank",
      "• Custom GUIs",
      "• Quests",
      "• Daily Rewards",
      "",
      "🔧 Improvements",
      "• Updated for the latest Minecraft Bedrock version",
      "• Mine progression improvements",
      "• Performance optimizations",
      "• General bug fixes",
      "",
      "⚠️ Beta Notice",
      "This addon is currently in Beta.",
      "Some features may still be in development.",
      "Please report any bugs or suggestions on our Discord!",
      "",
      "❤️ Thank you for supporting Vortex Network!"
    ],
    versionUrl: "https://raw.githubusercontent.com/RealModking/Vortex-Skyblock-addon/refs/heads/main/version.json",
    icon: "fa-bolt",
    description:
      "Start on your own floating island and expand your empire with challenges, generators, economy systems, and island upgrades.",
    features: [
      "Island Creation",
      "Challenges",
      "Generators",
      "Island Upgrades",
    ],
    ptext: "⚠️ Disclaimer: Two versions available - 'With Dynamic Properties' (may cause crashes on some devices) and 'Without Dynamic Properties' (Recommended - Stable & Crash-Free). Choose the version that works best for your setup.",
    curseforge: "https://www.curseforge.com/minecraft-bedrock/scripts/skyblock-addon",
    mcpedl: "https://mcpedl.com/skyblock-addon/",
    newdownloadlink: "https://vortexnetowrknew.co.uk/download/VNSkyblockBP.zip",
    withoutdy: "https://vortexnetowrknew.co.uk/download/VNSkyblockBPnody.zip",
    withoutdytextfile:"https://vortexnetowrknew.co.uk/download/withoutdytextfile.txt",
    withoutdyText: "✅ Stable & Recommended: This version has all features without dynamic properties. Provides the best stability and crash-free experience on all devices."
  },

  // {
  //   name: "Coming Soon",
  //   version: "Loading...",
  //   mcVersion: "Loading...",
  //   releaseDate: "Loading...",
  //   lastUpdate: "Loading...",
  //   changelog: ["coming soon..."],
  //   versionUrl: null, // No version URL since it's not released yet
  //   icon: "fa-puzzle-piece",
  //   description:
  //     "A brand new Vortex Network addon is currently in development. Expect advanced gameplay systems, unique mechanics, improved performance, and exciting new content designed for Minecraft Bedrock Edition.",
  //   features: [
  //     "New Gameplay Systems",
  //     "Custom Features",
  //     "Performance Optimized",
  //     "More Information Soon",
  //   ],
  //   curseforge: "#",
  //   mcpedl: "#",
  //   newdownloadlink: "#"
  // },
];

const Vortexdownload = () => {
  const { services, global } = useStatus();

  const [addons, setAddons] = useState(defaultAddons);
  const [selectedAddon, setSelectedAddon] = useState(defaultAddons[0]);
  const [showThankYou, setShowThankYou] = useState(false);

  const handleDownload = () => {
    setShowThankYou(true);
    setTimeout(() => setShowThankYou(false), 3000);
  };



  useEffect(() => {
    async function loadVersions() {
      const updatedAddons = await Promise.all(
        defaultAddons.map(async (addon) => {
          if (!addon.versionUrl) return addon;

          try {
            const res = await fetch(addon.versionUrl);
            const data = await res.json();

            return {
              ...addon,
              version: data.version,
              mcVersion: data.mcVersion,
              releaseDate: data.releaseDate,
              lastUpdate: data.lastUpdate,
              downloads: data.downloads || "Unknown",
            };
          } catch {
            return addon;
          }
        })
      );

      setAddons(updatedAddons);

      // 👇 only sync selected after load
      setSelectedAddon(updatedAddons[0]);
    }

    loadVersions();
  }, []);

  return (
    <div className="page">
      <div className="background-grid" />
      <div className="glow glow1" />
      <div className="glow glow2" />

      <div className="container">
        {/* HERO */}
        <header className="hero">
          <div className="hero-badge">
            <span className="hero-badge-dot" />
            <i className="fa-solid fa-shield-halved" />
            Vortex Network
          </div>

          <div className="hero-content">
            <div>
              <h1>Downloads <span>&amp; Network Status</span></h1>
              <p>
                Get the latest Vortex Network addons, check compatibility,
                view changelogs, and monitor our services in real time.
              </p>
            </div>

            <div className="hero-status">
              <div className={`hero-status-indicator ${global.color}`} />
              <div>
                <strong>{global.status}</strong>
                <small>Network status</small>
              </div>
            </div>
          </div>
        </header>

        {/* ADDON SELECTOR */}
        <div className="addon-tabs">
          {addons.map((addon) => (
            <button
              key={addon.name}
              className={`addon-tab ${selectedAddon.name === addon.name ? "active" : ""
                }`}
              onClick={() => setSelectedAddon(addon)}
            >
              <span className="addon-tab-icon">
                <i className={`fa-solid ${addon.icon}`} />
              </span>
              <span>
                <strong>{addon.name}</strong>
                <small>
                  {addon.version === "Loading..." ? "Loading..." : `${addon.version}`}
                </small>
              </span>
              {selectedAddon.name === addon.name && (
                <i className="fa-solid fa-chevron-right tab-arrow" />
              )}
            </button>
          ))}
        </div>

        <div className="main-grid">
          {/* DOWNLOAD PANEL */}
          <main className="download-card">
            <div className="section-top">
              <div className="section-label">
                <i className="fa-solid fa-download" />
                ADDON DOWNLOAD
              </div>
              <span className="version-pill">
                <i className="fa-solid fa-code-branch" />
                {selectedAddon.version}
              </span>
            </div>

            <div className="addon-heading">
              <div className="addon-icon-large">
                <i className={`fa-solid ${selectedAddon.icon}`} />
              </div>

              <div className="addon-heading-text">
                <h2>{selectedAddon.name}</h2>
                <p>{selectedAddon.description}</p>

                <div className="meta-row">
                  <span>
                    <i className="fa-brands fa-microsoft" />
                    Minecraft {selectedAddon.mcVersion}
                  </span>
                  <span>
                    <i className="fa-solid fa-calendar" />
                    Released {selectedAddon.releaseDate}
                  </span>
                  <span>
                    <i className="fa-solid fa-rotate" />
                    Updated {selectedAddon.lastUpdate}
                  </span>
                </div>
              </div>
            </div>

            <div className="content-section">
              <div className="section-title">
                <i className="fa-solid fa-sparkles" />
                <h3>Features</h3>
              </div>

              <div className="features">
                {selectedAddon.features.map((feature, i) => (
                  <div className="feature" key={i}>
                    <span className="feature-check">
                      <i className="fa-solid fa-check" />
                    </span>
                    <span>{feature}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="download-section">
              <div className="section-title">
                <i className="fa-solid fa-cloud-arrow-down" />
                <h3>Download</h3>
              </div>

              <div className="download-grid">
                <a
                  className="download-button primary"
                  href={selectedAddon.newdownloadlink}
                  download
                  onClick={handleDownload}
                >
                  <span className="button-icon">
                    <i className="fa-solid fa-globe" />
                  </span>
                  <span>
                    <strong>Official Download</strong>
                    <small>Direct from Vortex Network</small>
                  </span>
                  <i className="fa-solid fa-arrow-right button-arrow" />
                </a>



                <a
                  className="download-button curseforge"
                  href={selectedAddon.curseforge}
                  target="_blank"
                  rel="noreferrer"
                  onClick={handleDownload}
                >
                  <span className="button-icon">
                    <i className="fa-solid fa-cube" />
                  </span>
                  <span>
                    <strong>CurseForge</strong>
                    <small>Download from CurseForge</small>
                  </span>
                  <i className="fa-solid fa-arrow-up-right-from-square button-arrow" />
                </a>

                <a
                  className="download-button mcpedl"
                  href={selectedAddon.mcpedl}
                  target="_blank"
                  rel="noreferrer"
                  onClick={handleDownload}
                >
                  <span className="button-icon">
                    <i className="fa-solid fa-cubes" />
                  </span>
                  <span>
                    <strong>MCPEDL</strong>
                    <small>Download from MCPEDL</small>
                  </span>
                  <i className="fa-solid fa-arrow-up-right-from-square button-arrow" />
                </a>
              </div>

              {selectedAddon.withoutdy && (
                <>
                  {selectedAddon.ptext && (
                    <div className="notice-box">
                      <div className="notice-icon">
                        <i className="fa-solid fa-circle-info" />
                      </div>
                      <div>
                        <strong>Alternative Build</strong>
                        <p>{selectedAddon.ptext}</p>
                      </div>
                    </div>
                  )}
                  <div className="download-section">
                    <div className="section-title">
                      <i className="fa-solid fa-cloud-arrow-down" />
                      <h3>Alternative Build</h3>
                    </div>                 
                    <div className="download-grid">
                      <a
                        className="download-button primary"
                        href={selectedAddon.withoutdy}
                        download
                        onClick={handleDownload}
                      >
                        <span className="button-icon">
                          <i className="fa-solid fa-globe" />
                        </span>
                        <span>
                          <strong>Official Download (Without Dynamic Properties)</strong>
                          <small>Recommended - Stable & Crash-Free</small>
                        </span>
                        <i className="fa-solid fa-arrow-right button-arrow" />
                      </a>
                      {selectedAddon.withoutdytextfile && (
                        <a
                          className="download-button secondary"
                          href={selectedAddon.withoutdytextfile}
                          download
                          onClick={handleDownload}
                        >
                          <span className="button-icon">
                            <i className="fa-solid fa-file-alt" />
                          </span>
                          <span>
                            <strong>Info File</strong>
                            <small>Documentation & Details</small>
                          </span>
                          <i className="fa-solid fa-arrow-right button-arrow" />
                        </a>
                      )}
                    </div>
                  </div>
                  {selectedAddon.withoutdyText && (
                    <div className="notice-box">
                      <div className="notice-icon">
                        <i className="fa-solid fa-circle-check" />
                      </div>
                      <div>
                        <strong>Recommended Version</strong>
                        <p>{selectedAddon.withoutdyText}</p>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </main>

          {/* RIGHT COLUMN */}
          <aside className="side-column">
            {/* NETWORK STATUS */}
            <section className="status-wrapper">
              <div className="status-header">
                <div>
                  <div className="section-label">
                    <i className="fa-solid fa-server" />
                    SYSTEM MONITOR
                  </div>
                  <h2>Network Status</h2>
                </div>

                <div className={`global-status ${global.color}`}>
                  <span />
                  {global.status}
                </div>
              </div>

              <p className="status-updated">
                Last checked {global.lastUpdated}
              </p>

              <div className="cards">
                {services.map((service, i) => (
                  <StatusCard
                    key={i}
                    title={service.name}
                    status={
                      service.info
                        ? `${service.status} (${service.info})`
                        : service.status
                    }
                    color={service.color}
                  />
                ))}
              </div>
            </section>

            {/* QUICK STATS */}
            <section className="addon-stats">
              <div className="stat-card">
                <div className="stat-icon">
                  <i className="fa-solid fa-code-branch" />
                </div>
                <span>{selectedAddon.version}</span>
                <small>Current Version</small>
              </div>

              <div className="stat-card">
                <div className="stat-icon">
                  <i className="fa-solid fa-calendar-check" />
                </div>
                <span>{selectedAddon.lastUpdate}</span>
                <small>Last Update</small>
              </div>

              <div className="stat-card">
                <div className="stat-icon">
                  <i className="fa-solid fa-circle-check" />
                </div>
                <span>Active</span>
                <small>Addon Status</small>
              </div>
            </section>

            {/* CHANGELOG */}
            <section className="changelog-box">
              <div className="changelog-header">
                <div>
                  <div className="section-label">
                    <i className="fa-solid fa-clock-rotate-left" />
                    RELEASE HISTORY
                  </div>
                  <h2>Changelog</h2>
                </div>

                <span className="changelog-count">
                  {selectedAddon.changelog.filter(Boolean).length}
                </span>
              </div>

              <div className="changelog-list">
                {selectedAddon.changelog.map((entry, index) =>
                  entry ? (
                    <div className="changelog-entry" key={index}>
                      <span className="changelog-dot" />
                      <span>{entry}</span>
                    </div>
                  ) : (
                    <div className="changelog-space" key={index} />
                  )
                )}
              </div>
            </section>
          </aside>
        </div>

        <footer className="download-footer">
          <span>
            <i className="fa-solid fa-shield-halved" />
            Vortex Network
          </span>
          <span>Always use the latest compatible Minecraft Bedrock version.</span>
        </footer>

        {/* THANK YOU MODAL */}
        {showThankYou && (
          <div className="thank-you-modal-overlay">
            <div className="thank-you-modal">
              <div className="thank-you-icon">
                <i className="fa-solid fa-check-circle" />
              </div>
              <h2>Thank You for Downloading!</h2>
              <p>Your download will begin shortly. Enjoy your addon!</p>
            </div>
          </div>
        )}
      </div>
    </div>
  )

};




export default Vortexdownload;


